export default "__VITE_ASSET__DpZ4WJwm__"